<template>
  <div>
    <el-upload
      v-if="uploadFileType == 'file' || buttonType == 'text'"
      class="upload-demo"
      :limit="limit"
      :ref="uploadName"
      action=""
      :class="{ hide_box: fileList.length >= limit }"
      :auto-upload="false"
      :before-remove="handlebeforRemove"
      :on-remove="handleRemove"
      :on-change="
        (v) => {
          setBase64(v, 1);
        }
      "
      :file-list="fileList"
    >
      <div class="flex align-center" v-if="fileList.length < limit">
        <el-button
          size="mini"
          class="upBtn"
          v-if="bottonText == '选择文件'"
          type="info"
          >{{ bottonText }}</el-button
        >
        <el-button
          size="mini"
          class="upBtn"
          :class="{ bottonText: bottonText == '更换照片' }"
          v-else
          :type="buttonType"
          >{{ bottonText }}</el-button
        >
        <div
          slot="tip"
          class="el-upload__tip marginLeft-s"
          v-if="showTip && fileList.length == 0"
        >
          未选择任何文件
        </div>
      </div>
    </el-upload>
    <el-upload
      v-else
      class="editor-upload mb20"
      :ref="uploadName"
      multiple
      :limit="limit"
      action=""
      list-type="picture-card"
      :file-list="fileList"
      :auto-upload="false"
      :on-change="setBase64"
      :class="{ hide_box: fileList.length >= limit }"
    >
      <i slot="default" class="el-icon-plus" v-if="fileList.length < limit"></i>
      <div slot="file" slot-scope="{ file }">
        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
        <span class="el-upload-list__item-actions">
          <!-- <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span> -->
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
  
<script>
export default {
  name: "muploadfile",
  props: {
    fileList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    uploadFileType: {
      type: String,
      default: "",
    },
    imgKey: {
      type: String,
      default: "",
    },
    uploadName: {
      type: String,
      function() {
        return "upload";
      },
    },
    limit: {
      type: Number,
      default: 1,
    },
    canUpload: {
      type: Boolean,
      default: false,
    },
    FilePath: {
      type: String,
      default: "",
    },
    buttonType: {
      type: String,
      default: "info",
    },
    showTip: {
      type: Boolean,
      default: true,
    },
    bottonText: {
      type: String,
      default: "选择文件",
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      delName: "",
    };
  },
  methods: {
    onCancel() {
      this.$emit("onCancel");
    },
    beforeUpload1(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension8 = testmsg === "jpeg";
      const extension9 = testmsg === "jpg";
      const extension10 = testmsg === "bmp";
      const extension11 = testmsg === "gif";
      const extension12 = testmsg === "png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (
        !extension8 &&
        !extension9 &&
        !extension10 &&
        !extension11 &&
        !extension12
      ) {
        this.$message({
          message: "上传文件只能是jpeg/jpg/bmp/gif/png格式!",
          type: "warning",
        });
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 2MB!",
          type: "warning",
        });
      }
      console.log(this.uploadName, 20333);
      let { uploadFiles } = this.$refs[this.uploadName];
      uploadFiles.splice(uploadFiles.indexOf(file), 1);
      return (
        (extension8 && isLt2M) ||
        (extension9 && isLt2M) ||
        (extension10 && isLt2M) ||
        (extension11 && isLt2M) ||
        (extension12 && isLt2M)
      );
    },
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls";
      const extension2 = testmsg === "xlsx";
      const extension3 = testmsg === "ppt";
      const extension4 = testmsg === "pptx";
      const extension5 = testmsg === "docx";
      const extension6 = testmsg === "doc";
      const extension7 = testmsg === "pdf";
      const extension8 = testmsg === "jpeg";
      const extension9 = testmsg === "jpg";
      const extension10 = testmsg === "bmp";
      const extension11 = testmsg === "gif";
      const extension12 = testmsg === "png";
      const extension13 = testmsg === "zip";
      const extension14 = testmsg === "txt";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (
        !extension &&
        !extension2 &&
        !extension3 &&
        !extension4 &&
        !extension5 &&
        !extension6 &&
        !extension7 &&
        !extension8 &&
        !extension9 &&
        !extension10 &&
        !extension11 &&
        !extension12 &&
        !extension13 &&
        !extension14
      ) {
        this.$message({
          message:
            "只能上传xls/xlsx/ppt/pptx/docx/doc/pdf/jpeg/jpg/bmp/gif/png/zip/txt格式!",
          type: "warning",
        });
        let { uploadFiles } = this.$refs[this.uploadName];
        uploadFiles.splice(uploadFiles.indexOf(file), 1);
        return;
      }
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 2MB!",
          type: "warning",
        });
        let { uploadFiles } = this.$refs[this.uploadName];
        uploadFiles.splice(uploadFiles.indexOf(file), 1);
        return
      }
      return (
        (extension && isLt2M) ||
        (extension2 && isLt2M) ||
        (extension3 && isLt2M) ||
        (extension4 && isLt2M) ||
        (extension5 && isLt2M) ||
        (extension6 && isLt2M) ||
        (extension7 && isLt2M) ||
        (extension8 && isLt2M) ||
        (extension9 && isLt2M) ||
        (extension10 && isLt2M) ||
        (extension11 && isLt2M) ||
        (extension12 && isLt2M) ||
        (extension13 && isLt2M) ||
        (extension14 && isLt2M)
      );
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    setBase64(file, num) {
      let flag = true;
      if (num && this.buttonType != "text") {
        flag = this.beforeUpload(file);
      } else {
        flag = this.beforeUpload1(file);
      }
      if (!flag) {
        return;
      }
      this.getBase64(file.raw).then((res) => {
        let dataFile = res.split(",")[1];
        if (!dataFile) {
          this.$message("该文件为空文件或者不可用文件，请重新上传");
          return;
        }
        this.$api.returnGuid().then((guid) => {
          let type = file.name;
          type = type.split(".");
          let s = guid.substring(0, 3);
          let imgUrl = s + type[0],
            FilePath = this.FilePath ? this.FilePath : guid.substring(0, 1);
          // imgUrl = imgUrl.length > 20 ? imgUrl.substring(0, 19) : imgUrl; //限制文件名长度不超过20
          file.name = guid + "." + type[1];
          let obj = {
            upData: {
              guid,
              file,
              data: dataFile,
              that: this,
            },
            guid,
            name: guid + "." + type[1],
            url: file.url ? file.url : "",
            FilePath,
          };
          // let { fileList } = this;
          // fileList.push(obj)
          if (this.canUpload) {
            this.uploadFn(FilePath, file.size, dataFile, obj);
            return;
          }
          this.$emit("handleUpload", obj);
        });
      });
    },
    /**
     * @param file
     * @return base64
     * */
    getBase64(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file);
        //开始转
        reader.onload = function () {
          fileResult = reader.result;
        };
        //转 失败
        reader.onerror = function (error) {
          reject(error);
        };
        //转 结束  咱就 resolve 出去
        reader.onloadend = function () {
          resolve(fileResult);
        };
      });
    },
    uploadFn(FilePath, AppendSize, data, obj) {
      this.$loading();
      this.UpLoadFile({
        FileName: obj.name,
        FilePath,
        AppendSize,
        data: data,
        that: this,
      }).then((res) => {
        if (res == 1) {
          this.$message.success("上传成功");
          this.$emit("handleUpload", obj);
        } else {
          this.$message.error("上传失败");
          this.$emit("handleUpload", 1);
        }
        this.$loading().close();
      });
    },

    /**
     * @param FileName
     * @param FilePath  保存路径
     * @param file  文件
     * @param data  base64生成的data
     * @param obj   自定义需要传递的
     * @param AppendComplete  是否完成上传，主要用于分片
     * @param that  代表this
     *
     * @return base64
     * */
    UpLoadFile({
      FileName,
      FilePath,
      AppendSize,
      data,
      AppendComplete = true,
      that,
    }) {
      return new Promise((resolve, reject) => {
        FilePath = FilePath ? FilePath : FileName.substring(0, 1);
        that.$api
          .UpLoadFileFn(
            "FileName=" +
              FileName +
              "&FilePath=" +
              FilePath +
              "&AppendSize=" +
              AppendSize +
              "&AppendComplete=" +
              AppendComplete,
            data,
            { headers: { "Content-Type": "multipart/form-data" } }
          )
          .then((res) => {
            //console.log(res)
            if (res.data.OK == "True") {
              resolve(1);
            } else {
              resolve(res.data.Message);
            }
          });
      });
    },
    handlebeforRemove(file, fileList) {
      // this.delName=file;
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file) {
      if (this.canUpload) {
        //走接口
        this.deletePicFile(file);
      } else {
        this.deleteuploadFiles(file);
      }
    },
    deleteuploadFiles(file) {
      console.log(this.$refs[this.uploadName], this.uploadName);
      let { uploadFiles } = this.$refs[this.uploadName];
      let arr = [];
      if (uploadFiles.length > 0) {
        let i = uploadFiles.findIndex((it) => it.name == file.name);
        if (i >= 0) {
          uploadFiles.splice(i, 1);
        }
      }
      if (!this.canUpload || this.imgKey != "") {
        arr.push(file);
      }
      this.$loading().close();
      this.$emit("handleRemove", {
        delList: arr,
        fileList: uploadFiles,
        name: this.uploadName,
      });
    },
    deletePicFileFn(file, that) {
      console.log(file,417)
      that.$loading();
      return new Promise((resolve, reject) => {
        that.$api
          .deleteFn("?FileName=" + file.fileName + "&FilePath=" + file.filePath)
          .then((res) => {
            that.$loading().close();
            let result = res.data;
            if (result.OK != "True") {
              // that.$message(result.Message);
              resolve(2);
            } else {
              resolve(1);
            }
          });
      });
    },
    deletePicFile(file, i) {
      let p = file.name.split("."),
        fileName = p[0],
        filePath =
          this.FilePath != "" ? this.FilePath : fileName.substring(0, 1);
      this.$loading();
      this.deletePicFileFn({ fileName: file.name, filePath }, this).then(
        (res) => {
          // if (res == 1) {
          this.deleteuploadFiles(file, i);
          // }
        }
      );
    },
  },
};
</script>
<style>
.hide_box .el-upload,
.hide_box .el-upload--picture-card {
  display: none;
}
</style>
<style  scoped>
.upBtn {
  height: 22px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #2c9ef7;
  background-color: #f5f9fa;
  color: #2c9ef7;
  border-radius: 4px;
}
.bottonText {
  height: 30px;
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #2c9ef7;
  background-color: #ffffff;
  color: #2c9ef7;
  border-radius: 15px;
}
.relative {
  position: relative;
  min-height: 50px;
}

.relative .el-icon-circle-close {
  display: none;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9;
  font-size: 20px;
}
.relative:hover .el-icon-circle-close {
  display: block;
  cursor: pointer;
}
</style>
  


// WEBPACK FOOTER //
// src/components/upload.vue